<div *ngIf="defaultMapSource === 'google'; else esriMap" class="fs-map-wrapper">
  <sn-google-map
    [class.deleting]="isDeleting"
    [class.light]="mapStyle === 'light'"
    [class.satellite]="mapStyle === 'satellite'"
    [center]="center"
    [zoom]="zoom"
    [tilt]="tilt"
    (mapInit)="onMapInit($event)"
    (mapClick)="onMapClick($event)"
    (mapDblclick)="onMapDblclick($event)"
    (mapDragStart)="onMapDragStart()"
    (mapDrag)="onMapDrag()"
    (mapDragEnd)="onMapDragEnd()"
    (centerChange)="onCenterChange($event)"
    (boundsChange)="onBoundsChange($event)"
    (zoomChange)="onZoomChange($event)"
    (styleChange)="onStyleChange($event)"
  >
    <ng-container *ngTemplateOutlet="content"></ng-container>
  </sn-google-map>
</div>

<ng-template #esriMap>
  <fs-esri-map
    [mapOptions]="{ center: center, zoom: zoom, tilt: tilt }"
    [mapConstraints]="{ minZoom: 2, maxZoom: 23 }"
    esriMapTheme="arcgis-dark-gray"
    (mapInit)="onMapInit($event)"
    (mapClick)="onMapClick($event)"
    (mapDblclick)="onMapDblclick($event)"
    (mapDragStart)="onMapDragStart()"
    (mapDrag)="onMapDrag()"
    (mapDragEnd)="onMapDragEnd()"
    (centerChange)="onCenterChange($event)"
    (boundsChange)="onBoundsChange($event)"
    (zoomChange)="onZoomChange($event)"
    (styleChange)="onStyleChange($event)"
  >
    <ng-container *ngTemplateOutlet="content"></ng-container>
  </fs-esri-map>
</ng-template>

<ng-template #content>
  <ng-content></ng-content>
</ng-template>
